// extracted by mini-css-extract-plugin
export default {"searchBar":"Search_searchBar__Ke4ZN","button":"Search_button__e8G8p"};